import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DirectionsIcon from '@mui/icons-material/Directions';

import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';



const AlumniRequestTable = (props) => {
    return (
        <>
            {props.data ?

                <>

                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow className='bg-warning'>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Registration</TableCell>
                                    <TableCell align="center">Course</TableCell>
                                    <TableCell align="right">Batch</TableCell>
                                    <TableCell align="right">Passing Year</TableCell>

                                        <TableCell align="right">Action</TableCell>
                                    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.data && props.data.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.name}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.registration}
                                        </TableCell>
                                        <TableCell align="left">{row.course}</TableCell>
                                        <TableCell align="right">{row.batch}</TableCell>
                                        <TableCell align="right"> {row.passingYear} </TableCell>

                                        
                                            <TableCell align="right">
                                                <Button onClick={() => props.handleClickOpen(row)} variant='contained' size='small'><DirectionsIcon />View</Button>
                                            </TableCell>
                                        
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>

                :
                ''


            }
        </>
    )
}

export default AlumniRequestTable;